import React, { useEffect, useState } from "react";
import { Badge, Button, Card, Col, ListGroup, ListGroupItem, Row, Stack } from "react-bootstrap";
import SelectObject from "../../../ui/SelectObject";
import { fetchGoalTemplates, postGoal, postTask } from "../../../../services/httpClient";
import useApp from "../../../../utils/useApp";
import { Task } from "../../../../types/task";
import { useParams } from "react-router-dom";
import SelectFamily from "../../../ui/SelectFamily";

const UseGoalTemplate = ({ setShowToast, setToastText, setToastBody, family }: any) => {
  const { id } = useParams();
  const { auth }: any = useApp();
  const [selectedTemplateId, setSelectedTemplateId] = useState<string>("0");
  const [selectedTemplate, setSelectedTemplate] = useState<any>();
  const [templates, setTemplates] = useState<any[]>();
  const [familyUser, setFamilyUser] = useState<string>("unassigned");

  useEffect(() => {
    getTemplates();
  }, []);

  useEffect(() => {
    const realFamily = (family || []).filter((member: any) => member.name !== "Unassigned");
    if (realFamily.length === 1) {
      setFamilyUser(realFamily[0].id + "|" + realFamily[0].type);
    }
  }, [family]);

  const getTemplates = () => {
    fetchGoalTemplates(auth?.profile?.userOrgID)
      .then((res: any) => {
        var temps = res[0].data;
        temps = temps.map((t: any) => {
          return { ...t, key: t.id };
        });
        setTemplates(temps);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const updateTemplate = (e: any) => {
    setSelectedTemplateId(e.target.value);
    const selected = templates?.filter((t: any) => {
      return t?.id == e.target.value;
    });
    setSelectedTemplate(selected);
  };

  const onClickCreateGoal = async () => {
    const selected = selectedTemplate[0];
    const newGoal: any = {
      name: selected.name,
      category_id: selected.category_id,
      order: selected.order,
      is_completed: false,
      is_archived: false,
      goal_template_id: selected.id,
    };

    if (familyUser && familyUser !== "unassigned" && !familyUser.toLowerCase().includes("unassigned")) {
      const parts = familyUser.split("|");
      if (parts.length === 2 && parts[0] && parts[1]) {
        newGoal.subject = { id: parts[0], type: parts[1] };
      }
    }

    try {
      const res = await postGoal(newGoal, id);
      const response = res[0].data;
      const goalId = response?.goal_id;
      const tasksToCreate = (selected.tasks ?? []).slice().sort((a: any, b: any) => (a?.order || 0) - (b?.order || 0));

      for (const t of tasksToCreate) {
        const newTask = {
          name: t?.name,
          order: t?.order,
          is_next: false,
          is_completed: false,
          is_cm_reviewed: false,
          is_archived: false,
        };
        await postTask(newTask, id, goalId);
      }

      setSelectedTemplateId("0");
      setSelectedTemplate(null);
      setShowToast(true);
      setToastText("Goal Created");
      setToastBody(selected?.name);
    } catch (err) {
      console.error(err);
    }
  };

  const updateFamilyUser = (e: any) => {
    setFamilyUser(e.target.value);
  };

  return (
    <>
      <Row>
        <Col xs={12}>
          <SelectObject label="Goal Template" value={selectedTemplateId} options={templates} onUpdate={(e: any) => updateTemplate(e)} />
        </Col>
      </Row>
      {selectedTemplateId !== "0" && (
        <>
          <Row>
            <Card className="bg-light p-3 mb-3">
              <SelectFamily family={family} familyUser={familyUser} updateFamilyUser={updateFamilyUser} skipDefaultSelection={true} />
              <Row className="mt-3">
                <Col xs={12}>
                  <Stack direction="horizontal" gap={3}>
                    <h5 className="app-orange-text">{selectedTemplate[0]?.name}</h5>
                    <Badge bg="secondary" className="ms-auto">
                      {selectedTemplate[0]?.category_name}
                    </Badge>
                  </Stack>
                </Col>
              </Row>
              <Row>
                <h6>Tasks</h6>
              </Row>
              <Row className="mx-0">
                <ListGroup className="px-0">
                  {selectedTemplate[0]?.tasks?.map((t: Task) => (
                    <ListGroupItem key={t?.id}>
                      <Row>
                        <Col className="col-11">{t?.name}</Col>
                      </Row>
                    </ListGroupItem>
                  ))}
                </ListGroup>
              </Row>
            </Card>
            <Row>
              <Col className="text-center">
                <Button className="button app-primary-color" onClick={() => onClickCreateGoal()}>
                  Create Goal From Template
                </Button>
              </Col>
            </Row>
          </Row>
        </>
      )}
    </>
  );
};

export default UseGoalTemplate;
